<template>
        <div class="flex justify-center items-center flex-wrap h-full g-6 ">
           <div class="mb-4 text-sm text-gray-600 dark:text-gray-400"> </div>

    <form @submit.prevent="submit">
        <div class="grid gap-6">
            <!-- Mobile input -->
            <div class="space-y-2">
                <Label for="mobile" value="موبایل" class="text-white" />
                <InputIconWrapper>
                    <template #icon>
                        <MailIcon aria-hidden="true" class="w-5 h-5" />
                    </template>
                    <Input
                        withIcon
                        id="mobile"
                        type="mobile"
                        class="block Mobile-full"
                        placeholder="موبایل  09121234567"
                        v-model="forgotPasswordForm.mobile"
                        required
                        autofocus
                        autocomplete="username"
                    />
                </InputIconWrapper>
            </div>

            <!-- Submit button -->
            <div>
                <Button
                    type="submit"
                    class="justify-center w-full gap-2"
                    :disabled="forgotPasswordForm.processing"
                    v-slot="{ iconSizeClasses }"
                >
                    <PaperAirplaneIcon aria-hidden="true" :class="iconSizeClasses" />
                    <span>موبایل</span>
                </Button>
            </div>
        </div>
    </form>
</div>
</template>

<script setup>
import { reactive } from 'vue'
import InputIconWrapper from '@/components/InputIconWrapper.vue'
import Button from '@/components/Button.vue'
import Input from '@/components/Input.vue'
import Label from '@/components/Label.vue'
import { MailIcon, PaperAirplaneIcon } from '@heroicons/vue/outline'
import { useStore } from "vuex"
import { useRouter } from 'vue-router';
const router = useRouter()
const store = useStore()

const forgotPasswordForm = reactive({
    mobile: '',
    processing: false
})

const submit = () => {
    store.dispatch('forgotpassword', forgotPasswordForm)
          .then(() => {
            router.push({name: 'ResetPassword'})
          }).catch(() => {
      })
}
</script>
